import { PageTitle } from "@/components/site/PageTitle";
import { CHI_SIAMO } from "@/lib/data";

export default function ChiSiamo() {
  return (
    <div data-testid="chi-siamo-page">
      <PageTitle title="Chi siamo" crumbs={[{ label: "Chi siamo" }]} />
      <div className="max-w-[1240px] mx-auto px-4 pt-10">
        <div className="max-w-[820px]">
          <img src="/img/chi-siamo-2.jpg" alt="IVCasa chi siamo" className="w-full h-auto" />
          <hr className="my-10 border-gray-300" />
          <h2 className="font-tit font-bold text-[var(--iv)] uppercase text-4xl sm:text-5xl mb-8">Chi siamo</h2>
          {CHI_SIAMO.map((b, i) => (
            <div key={i} className="mb-6">
              {b.h && <h3 className="font-tit font-bold text-[var(--iv)] uppercase text-2xl mb-3">{b.h}</h3>}
              {b.p.map((p) => <p key={p} className="leading-7 mb-3">{p}</p>)}
            </div>
          ))}
          <img src="/img/chi-siamo.jpg" alt="IVCasa" className="w-full h-auto mt-6" />
        </div>
      </div>
    </div>
  );
}
